export default __webpack_public_path__ + "static/media/secret-swap.35e63ff4.svg";